export enum PatientsTableColumn {
  NAME = 'name',
  BIRTHDAY = 'birthday',
  ORGANIZATION = 'organization',
  SYNC_STATE = 'syncState',
  BP_TYPE = 'bpType',
}
